"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCarouselOptions = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _constants = require("./constants");
/**
 * Hook for generating Categories Carousel options.
 * @returns Categories Carousel options.
 */ const useCarouselOptions = ()=>{
    const { breakpoints: { values: { sm } } } = (0, _mui.useTheme)();
    const showArrows = (0, _mui.useMediaQuery)((theme)=>theme.breakpoints.up('lg'));
    return (0, _react.useMemo)(()=>({
            hasFocusableSlides: true,
            navigation: {
                position: 'outside',
                showArrows,
                size: 'medium'
            },
            pagination: {
                show: false
            },
            slider: {
                loop: false,
                slides: {
                    perView: 'auto',
                    spacing: _constants.MOBILE_GAP
                },
                breakpoints: {
                    ["(min-width: ".concat(sm, "px)")]: {
                        slides: {
                            perView: 'auto',
                            spacing: _constants.DESKTOP_GAP
                        }
                    }
                }
            }
        }), [
        showArrows,
        sm
    ]);
};
exports.useCarouselOptions = useCarouselOptions;
